import React from "react";
import { useSelector } from "react-redux";
import { Layout, Image, Row, Col } from "antd";
import logoRegione from "../../styles/images/loghi/regione.png";
import logoLD from "../../styles/images/loghi/ld.png";
import { ottieniInfoStruttura } from "./utility";
import { PATH_REGIONE, PATH_LIGURIA_DIGITALE } from "../../path";
import { isMobileMode } from "../../modules/configuration";
import { getInfoIntervento, ID_STRUTTURA } from "../../modules/surgery";

const { Footer: AntdFooter } = Layout;

export const Footer = () => {
  const mobileMode = useSelector(isMobileMode);
  const infoIntervento = useSelector(getInfoIntervento);
  const idStruttura =
    infoIntervento &&
    infoIntervento !== undefined &&
    infoIntervento[ID_STRUTTURA] &&
    infoIntervento[ID_STRUTTURA] !== undefined
      ? infoIntervento[ID_STRUTTURA]
      : null;

  const LogoParametrizzato = ({ idStruttura }) => {
    const logoInfo = ottieniInfoStruttura(idStruttura);
    return (
      <a href={logoInfo.href} target="_blank" rel="noopener noreferrer">
        <Image id={logoInfo.id} alt={logoInfo.alt} src={logoInfo.src} preview={false} />
      </a>
    );
  };

  return (
    <AntdFooter className={mobileMode ? "mobileFooter" : "desktopFooter"}>
      <Row>
        {/* prettier-ignore */}
        <Col xs={idStruttura ? 10 : 12} sm={idStruttura ? 10 : 12} md={idStruttura ? 14 : 12} lg={idStruttura ? 16 : 12} xl={idStruttura ? 17 : 12} className="logoLD">
            <a href={PATH_LIGURIA_DIGITALE} target="_blank" rel="noopener noreferrer">
              <Image id="liguriaDigitale" alt="Logo LiguriaDigitale" src={logoLD} preview={false} />
            </a>
          </Col>
        {idStruttura && (
          <Col xs={7} sm={7} md={6} lg={4} xl={4}>
            <LogoParametrizzato idStruttura={idStruttura} />
          </Col>
        )}
        {/* prettier-ignore */}
        <Col xs={idStruttura ? 7 : 12} sm={idStruttura ? 7 : 12} md={idStruttura ? 4 : 12} lg={idStruttura ? 4 : 12} xl={idStruttura ? 3 : 12}>
            <a href={PATH_REGIONE} target="_blank" rel="noopener noreferrer">
              <Image id="regione" alt="Logo Regione" src={logoRegione} preview={false} />
            </a>
          </Col>
      </Row>
    </AntdFooter>
  );
};
